import { ActionButton } from './DiagramSelectionBar';

/**
 * Kurze Uebersicht der Bedienung des Skizzeneditors: Gesten mit Finger oder Maus und Tastenkuerzel. Steht unter dem Knopf
 * "Bedienung" ueber dem Feld und laesst sich dort wieder schliessen. Knapp gehalten - die Werkzeuge erklaeren sich in der
 * Hinweiszeile unter dem Feld.
 */

const GESTURES: ReadonlyArray<{ term: string; text: string }> = [
  { term: 'Tippen', text: 'Mit einem Werkzeug setzt es ein Element oder einen Punkt, bei „Auswählen“ markiert es das Element.' },
  { term: 'Ziehen', text: 'Bei „Auswählen“ verschiebt es das Element, mit Pfeil-, Zonen- und Maßwerkzeug zeichnet es. Auf leerer Fläche zieht es einen Rahmen auf (gezoomt: schwenkt das Feld).' },
  { term: 'Kurve ziehen', text: 'Mit Laufweg, Dribbling und Wechsel ergibt ein gezogener Bogen einen weichen Pfeil. Mehrmals tippen setzt Knickpunkte, „Fertig“ beendet den Pfeil.' },
  { term: 'Pass, Schuss', text: 'Immer gerade, auch krumm gezogen. Einen Knick setzt „Knick hinzufügen“ in der Auswahl. Mit „Hinwechseln“ läuft der Passgeber dem Pass nach.' },
  { term: 'Mehrere Schritte', text: 'Ein markierter Laufweg, Dribbling oder Wechsel kann mit „Läuft bis Schritt“ ohne Halt über mehrere Schritte laufen – so wirkt der Ablauf flüssiger.' },
  { term: 'Doppeltipp', text: 'Auf einen Text: bearbeiten. Auf die Linie eines Pfeils: neuer Knick. Auf einen Knick: entfernen. Auf den blauen Biegepunkt: Pfeil wieder gerade.' },
  { term: 'Zwei Finger', text: 'Zoomen und das Feld schwenken. Am Computer zoomt Strg + Mausrad.' },
];

const KEYS: ReadonlyArray<{ term: string; text: string }> = [
  { term: 'Strg + Z', text: 'Rückgängig' },
  { term: 'Strg + Y oder Strg + Umschalt + Z', text: 'Wiederherstellen' },
  { term: 'Entf oder Rück', text: 'Markierte Elemente löschen' },
  { term: 'Pfeiltasten', text: 'Markierte Elemente schieben (mit Umschalt in größeren Schritten)' },
  { term: 'Strg + A', text: 'Alles markieren' },
  { term: 'Umschalt- oder Strg-Klick', text: 'Element zur Auswahl hinzufügen oder herausnehmen' },
];

function Entries({ title, entries }: { title: string; entries: ReadonlyArray<{ term: string; text: string }> }): JSX.Element {
  return (
    <div className="space-y-1.5">
      <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</h4>
      <dl className="space-y-1.5">
        {entries.map((entry) => (
          <div key={entry.term} className="grid grid-cols-[minmax(5.5rem,34%)_1fr] gap-x-3 text-sm">
            <dt className="font-semibold text-slate-800">{entry.term}</dt>
            <dd className="text-slate-600">{entry.text}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}

export function DiagramHelp({ id, onClose }: { id: string; onClose: () => void }): JSX.Element {
  return (
    <section id={id} aria-label="Bedienung" data-testid="diagram-help" className="space-y-3 rounded-xl border border-brand-200 bg-brand-50/60 p-3">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold text-slate-900">Bedienung des Skizzeneditors</h3>
        <ActionButton label="Bedienung schließen" icon="close" onClick={onClose}>
          Schließen
        </ActionButton>
      </div>
      <Entries title="Mit Finger oder Maus" entries={GESTURES} />
      <Entries title="Tastatur (Feld zuerst antippen)" entries={KEYS} />
    </section>
  );
}
